import {
  FileCheck, Plane, CalendarDays, Mail, Folder, Calendar, BookOpen, Contact,
  MessageCircle, Clock, Target, type LucideIcon,
} from '../../../icons';
import type { WidgetActions } from './widget-context';

/**
 * 「빠른 실행」 카탈로그 — 시안 화면 L ⑥ (2026-09-09 · 판 5).
 *
 * ★★★ **고정 여덟으로 만들지 않는다.** 시안이 그려 준 여덟은 «예시»다 — 회사마다 자주 하는 일이
 *     다르고, 고정으로 두면 절반은 아무도 안 누른다(설계 §12 의 경고). 그래서 카탈로그를
 *     여기 한 곳에 두고, **무엇을 놓을지는 사용자가 위젯 설정에서 고른다.**
 * ★★★ **끈 메뉴는 카탈로그에서 빠진다.** 못 가는 곳을 눌러 보게 하는 것은 잘못된 안내다 —
 *     `menuKey` 가 있는 항목은 그 메뉴가 꺼져 있으면 고를 수도, 보일 수도 없다.
 * ★★ 「휴가 신청」은 주소가 아니라 **창**이다(근태 신청 모달). 그래서 항목이 `to` 가 아니라
 *    `run` 을 갖는다 — 바로가기의 목적지가 늘 라우트인 것은 아니다.
 */

export interface QuickLinkDef {
  key: string;
  label: string;
  icon: LucideIcon;
  /** 이 바로가기가 딸린 메뉴. 관리자가 껐으면 고를 수도 보일 수도 없다. */
  menuKey?: string;
  run: (actions: WidgetActions) => void;
}

export const QUICK_LINKS: QuickLinkDef[] = [
  { key: 'approval-new', label: '기안 작성', icon: FileCheck, menuKey: 'approval', run: (a) => a.go('/approval/new') },
  { key: 'approval-pending', label: '결재 대기', icon: FileCheck, menuKey: 'approval', run: (a) => a.go('/approval/pending') },
  { key: 'leave', label: '휴가 신청', icon: Plane, menuKey: 'attendance', run: (a) => a.openAttendanceRequest('leave') },
  { key: 'attendance', label: '내 근태', icon: Clock, menuKey: 'attendance', run: (a) => a.go('/erp/attendance') },
  { key: 'reservation', label: '회의실 예약', icon: CalendarDays, menuKey: 'reservation', run: (a) => a.go('/reservation/book') },
  { key: 'mail-compose', label: '메일 쓰기', icon: Mail, menuKey: 'mail', run: (a) => a.go('/mail/compose') },
  { key: 'workspace', label: '문서함', icon: Folder, menuKey: 'workspace', run: (a) => a.go('/workspace') },
  { key: 'calendar', label: '일정', icon: Calendar, menuKey: 'calendar', run: (a) => a.go('/calendar') },
  { key: 'board', label: '게시판', icon: BookOpen, menuKey: 'board', run: (a) => a.go('/board') },
  { key: 'contacts', label: '명함첩', icon: Contact, menuKey: 'contacts', run: (a) => a.go('/contacts') },
  { key: 'chat', label: '대화', icon: MessageCircle, menuKey: 'chat', run: (a) => a.go('/chat') },
  { key: 'task', label: '할일', icon: Target, menuKey: 'task', run: (a) => a.go('/task') },
];

/** 고르지 않았을 때 놓이는 것 — 시안이 그린 여덟 중 «메뉴가 켜져 있는 것»만 남는다. */
export const DEFAULT_QUICK_LINKS = [
  'approval-new', 'leave', 'reservation', 'mail-compose', 'workspace', 'calendar', 'board', 'contacts',
];

const BY_KEY = new Map(QUICK_LINKS.map((d) => [d.key, d]));

export function getQuickLink(key: string): QuickLinkDef | undefined {
  return BY_KEY.get(key);
}
